import { NavLink } from "react-router-dom";
import { LayoutDashboard, CheckSquare, ShoppingBag, CalendarDays, StickyNote, BookHeart } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { AccountMenu } from "@/components/AccountMenu";
import { HomeBalanceIcon } from "@/components/Logo";

const NAV = [
  { to: "/", label: "Overview", icon: LayoutDashboard, id: "dashboard" },
  { to: "/todos", label: "To-Do Lists", icon: CheckSquare, id: "todos" },
  { to: "/lists", label: "Wishlists & To-Buy", icon: ShoppingBag, id: "lists" },
  { to: "/calendar", label: "Calendar", icon: CalendarDays, id: "calendar" },
  { to: "/notes", label: "Notes", icon: StickyNote, id: "notes" },
  { to: "/diary", label: "Diary", icon: BookHeart, id: "diary" },
];

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-[background-color,color] duration-200 whitespace-nowrap ${
    isActive ? "bg-t-ink text-t-bg" : "text-t-c4 hover:bg-t-surface-hover/60"
  }`;

export const Sidebar = () => (
  <aside className="lg:w-72 lg:h-screen lg:sticky lg:top-0 shrink-0 bg-t-surface border-b lg:border-b-0 lg:border-r border-t-line z-20">
    <div className="flex lg:flex-col h-full p-4 lg:p-6 gap-4 lg:gap-6 overflow-x-auto lg:overflow-visible">
      <div className="flex items-center gap-3 lg:px-2 shrink-0" data-testid="app-logo">
        <div className="h-11 w-11 rounded-2xl bg-t-card border border-t-line flex items-center justify-center shadow-sm">
          <HomeBalanceIcon />
        </div>
        <div className="hidden sm:block">
          <p className="font-serif-display text-2xl font-semibold leading-none">Base &amp; Balance</p>
          <p className="text-[10px] tracking-[0.25em] uppercase text-t-muted mt-1">Home & Life</p>
        </div>
      </div>
      <nav className="flex lg:flex-col gap-1 overflow-x-auto flex-1">
        {NAV.map(({ to, label, icon: Icon, id }) => (
          <NavLink key={id} to={to} end={to === "/"} className={linkCls} data-testid={`nav-${id}`}>
            <Icon className="h-4 w-4" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <div className="flex lg:flex-col gap-2 shrink-0">
        <AccountMenu />
      </div>
      <SideImage />
    </div>
  </aside>
);


const SideImage = () => {
  const { theme } = useTheme();
  return (
      <div className="hidden lg:block rounded-2xl overflow-hidden relative h-32 shrink-0">
        <img
          src={theme.side}
          alt="Calm home"
          data-testid="sidebar-image"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
        <p className="absolute bottom-3 left-4 right-4 font-serif-display italic text-lg text-white leading-tight">
          A calm home begins with a gentle plan.
        </p>
      </div>
  );
};
